import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProtectedRoute from '../../system/components/ProtectedRoute';
import { UserRoles } from '../../system/types';

// Créer des fichiers routes.tsx pour chaque sous-dossier
import BallonsDueToClubRoutes from './BallonsDueToClub/routes';
import FactureViewRoutes from './FactureView/routes';
import ParrainageViewRoutes from './ParrainageView/routes';
import ReconductionsPourImpressionRoutes from './ReconductionsPourImpression/routes';
import ReconductionsPourAssistantPotentielRoutes from './ReconductionsPourAssistantPotentiel/routes';
import ReconductionsABloquerRoutes from './ReconductionsABloquer/routes';
import ParrainagesCurrentMonthRoutes from './ParrainagesCurrentMonth/routes';
import MaterialDueToClubRoutes from './MaterialDueToClub/routes';
import ListeNoireRoutes from './ListeNoire/routes';
import ACVFDuMoisRoutes from './ACVFDuMois/routes';

// Définition des permissions requises pour chaque module de vue
const modulePermissions: Record<string, UserRoles[]> = {
    BallonsDueToClub: ['ADMIN', 'USER'],
    FactureView: ['ADMIN', 'USER'],
    ParrainageView: ['ADMIN', 'USER'],
    ReconductionsPourImpression: ['ADMIN', 'USER'],
    ReconductionsPourAssistantPotentiel: ['ADMIN', 'USER'],
    ReconductionsABloquer: ['ADMIN', 'USER'],
    ParrainagesCurrentMonth: ['ADMIN', 'USER'],
    MaterialDueToClub: ['ADMIN', 'USER'],
    ListeNoire: ['ADMIN', 'USER'],
    ACVFDuMois: ['ADMIN', 'USER'],
};

/**
 * Centralise les routes de la section "view"
 * Tous les modules s'enregistrent ici automatiquement
 */
const ViewRoutes: React.FC = () => {
    // Fonction pour wrapper les routes de chaque module avec ProtectedRoute
    const protectRoutes = (
        routes: React.ReactElement[],
        requiredRoles: UserRoles[]
    ) => {
        return routes.map((route, index) => {
            // Cloner la route existante avec ses props
            return (
                <Route
                    key={`protected-${index}`}
                    path={route.props.path}
                    element={
                        <ProtectedRoute requiredRoles={requiredRoles}>
                            {route.props.element}
                        </ProtectedRoute>
                    }
                />
            );
        });
    };

    // Combinaison des routes protégées
    const allModuleRoutes = [
        ...protectRoutes(
            BallonsDueToClubRoutes,
            modulePermissions.BallonsDueToClub
        ),
        ...protectRoutes(FactureViewRoutes, modulePermissions.FactureView),
        ...protectRoutes(
            ParrainageViewRoutes,
            modulePermissions.ParrainageView
        ),
        ...protectRoutes(
            ReconductionsPourImpressionRoutes,
            modulePermissions.ReconductionsPourImpression
        ),
        ...protectRoutes(
            ReconductionsPourAssistantPotentielRoutes,
            modulePermissions.ReconductionsPourAssistantPotentiel
        ),
        ...protectRoutes(
            ReconductionsABloquerRoutes,
            modulePermissions.ReconductionsABloquer
        ),
        ...protectRoutes(
            ParrainagesCurrentMonthRoutes,
            modulePermissions.ParrainagesCurrentMonth
        ),
        ...protectRoutes(
            MaterialDueToClubRoutes,
            modulePermissions.MaterialDueToClub
        ),
        ...protectRoutes(ListeNoireRoutes, modulePermissions.ListeNoire),
        ...protectRoutes(ACVFDuMoisRoutes, modulePermissions.ACVFDuMois),
    ];

    return <Routes>{allModuleRoutes}</Routes>;
};

export default ViewRoutes;
